// extracted by mini-css-extract-plugin
export default {"services":"Services_services__01f5n","boxContainer":"Services_boxContainer__SFC8s","box":"Services_box__gsbRm"};